import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import BottomNavigation from "../components/BottomNavigation";
import { tNode } from "../services/i18n";
import { track } from "../services/analytics";

interface Article { title: string; body: string; }

export default function HelpArticlePage() {
  const { article } = useParams();
  const articles = tNode<Record<string, Article>>("helpPage.articles", {});
  const data = article ? articles[article] : undefined;
  useEffect(() => {
    if (data) track("help_article_viewed");
  }, [data]);

  if (!data) return <Navigate to="/help" replace />;

  return (
    <>
      <AppHeader title={data.title} backTo="/help" />
      <div className="page page--with-nav">
        <div className="card">
          <p>{data.body}</p>
        </div>
      </div>
      <BottomNavigation />
    </>
  );
}
